export default __webpack_public_path__ + "static/media/v-plex.41f59b9e.png";